{
  "version": 1,
  "asset_id": "1f93ef2e-2beb-41ea-9958-12fcec2a1db3",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/1f93ef2e-2beb-41ea-9958-12fcec2a1db3/bypass-revision-completed-pouch-es.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/1f93ef2e-2beb-41ea-9958-12fcec2a1db3/bypass-revision-completed-pouch-es.webp",
  "original_filename": "bypass-revision-completed-pouch-es.webp",
  "size": 157150,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:36Z"
}
